import { Route, Routes, Navigate } from 'react-router-dom'
import { adminRoutes, authRoutes, instructorRoutes, edunavRoutes } from '@/routes/index'
import AdminLayout from '@/layouts/AdminLayout'
import InstructorLayout from '@/layouts/InstructorLayout'
import OtherLayout from '@/layouts/OtherLayout'
import { useAuthContext } from '@/context/useAuthContext'
import ShopLayout from '@/layouts/ShopLayout'
import EduNavLayout from '@/layouts/EduNavLayout'
const AppRouter = (props) => {
  const { user, isAuthenticated } = useAuthContext()
  return (
    <Routes>
      {(edunavRoutes || []).map((route, idx) => (
        <Route key={idx + route.name} path={route.path} element={<EduNavLayout {...props}>{route.element}</EduNavLayout>} />
      ))}
      {(authRoutes || []).map((route, idx) => (
        <Route key={idx + route.name} path={route.path} element={<OtherLayout {...props}>{route.element}</OtherLayout>} />
      ))}

      {/* Admin routes */}
      <Route
        path="/admin/*"
        element={
          isAuthenticated && user?.role === 'Admin' ? (
            <AdminLayout {...props}>
              <Routes>
                {(adminRoutes || []).map((route, idx) => (
                  <Route key={idx + route.name} path={route.path.replace('/admin', '')} element={route.element} />
                ))}
              </Routes>
            </AdminLayout>
          ) : (
            <Navigate to="/auth/sign-in" />
          )
        }
      />
      {/* Instructor routes */}
      <Route
        path="/instructor/*"
        element={
          isAuthenticated && user?.role === 'User' ? (
            <InstructorLayout {...props}>
              <Routes>
                {(instructorRoutes || []).map((route, idx) => (
                  <Route key={idx + route.name} path={route.path.replace('/instructor', '')} element={route.element} />
                ))}
              </Routes>
            </InstructorLayout>
          ) : (
            <Navigate to="/auth/sign-in" />
          )
        }
      />
    </Routes>
  )
}
export default AppRouter
